import { BrandImage } from '../../modules/BrandEdit';
import { showSnackbarWithMessage } from '../Snackbar/snackbar.saga';
import { callApi } from '../api';
import {
  cmsBrandFetchCallOptions,
  cmsBrandSaveCallOptions,
} from '../../services/cmsbrands.services';
import {
  editBrandFetched,
  resetBrandEdit,
  saveEditBrand,
  setCmsBrand,
  startLoading,
  stopLoading,
} from './brand-edit.actions';
import { call, fork, put, select, take } from 'redux-saga/effects';
export function* watchForBrandEditStart() {
  while (true) {
    const {
      payload: { cmsBrandId },
    } = yield take(setCmsBrand.type);
    yield call(brandEditStart, cmsBrandId);
  }
}

export function* brandEditStart(cmsBrandId: number) {
  yield put(resetBrandEdit());
  yield put(startLoading());

  const getCallOptions = cmsBrandFetchCallOptions(cmsBrandId);
  const cmsBrandResponse = yield call(callApi, getCallOptions);
  if (!cmsBrandResponse || !cmsBrandResponse.ok) {
    yield showSnackbarWithMessage('error', 'Could not fetch brand (CMS)');
    return;
  }

  yield put(editBrandFetched({ cmsBrand: cmsBrandResponse.data || {} }));

  yield put(stopLoading());
}

export function* watchForBrandEditSave() {
  while (true) {
    const {
      payload: { images, gender },
    } = yield take(saveEditBrand.type);
    yield call(brandEditSave, images, gender);
  }
}

export function* brandEditSave(images: BrandImage[], gender: string) {
  const {
    brandEdit: { cmsBrand },
  } = yield select() as any;
  const saveCallOptions = cmsBrandSaveCallOptions({
    ...cmsBrand,
    images: images,
    gender: gender,
  });
  const brandResponse = yield call(callApi, saveCallOptions);
  if (brandResponse.ok) {
    yield fork(showSnackbarWithMessage, 'success', 'Brand data saved');
  } else {
    showSnackbarWithMessage('error', 'Brand could not be saved');
  }
}



// WEBPACK FOOTER //
// ./src/store/BrandEdit/brand-edit.saga.ts